export default __webpack_public_path__ + "static/media/yogatimeTwitter-600x314.e1e7d4cc.jpg";